import React, { useEffect, useState } from 'react';
import LoadingOverlay from 'react-loading-overlay';
import {
  addPremiumItemToCart,
  deleteCartItems,
  displayStockLevelStatus,
  getPriceFormat,
  getPriceWithoutCurrency,
  updateCart
} from '../../../services/promotion/utils.service';
import LiffPromotionList from '../../modal/LiffPromotionList';
import '../../promotion/CartPromotion.scss';
import QuantityStepper from '../QuantityStepper';
import CustomSweetAlert from '../../../common/customSweetAlert/CustomSweetAlert';

export const PromotionItem = ({
  index,
  img,
  identifier,
  quantity,
  premiumItemsOption,
  cart,
  lastPremiumItemsId,
  elligibleTargetQty,
  hasElligibleTargetQty,
  totalPrice,
  callback,
  fetchCart,
  stock,
  isOpenLiff,
  onOpenLiff,
  onCloseLiff
}) => {

  const [loading, setLoading] = useState(false);
  const [orderTotal, setOrderTotal] = useState(0);

  useEffect(() => {
    setOrderTotal(elligibleTargetQty + hasElligibleTargetQty + getQuantity());
  }, [elligibleTargetQty, hasElligibleTargetQty, identifier]);

  const closeLiffEvent = () => {
    // if (!isRequiredQtySelected()) {
    //   return CustomSweetAlert({
    //     title: "",
    //     text: 'Kindly select the complete configured promotion quantity.',
    //     confirmButtonText: "ตกลง",
    //   });
    // }
    onCloseLiff();
    fetchCart();
  };

  const increaseOrder = async (option) => {
    if (isRequiredQtySelected()) {
      return CustomSweetAlert({
        title: "",
        text: 'ไม่สามารถเพิ่มจำนวนสินค้าได้ เนื่องจากถึงจำนวนที่จำกัดแล้ว',
        confirmButtonText: "ตกลง",
      });
    }
    setLoading(true);
    const product = cart.entries.find(
      (value) => value.product.id === option.id && value.partnerPromotionId === index.code
    );
    const deleteLocal = JSON.parse(localStorage.getItem('deleteIds'));
    totalPrice = +totalPrice + getPriceWithoutCurrency(option.targetPrice);
    let data = null;
    if (!product || product?.quantity === 0) {
      data = await addPremiumItemToCart(cart.id, option, 1, product?.partnerPromotionId || index?.code);
      const newDeleteLocal = deleteLocal.filter(
        (v) => v.product.id !== option.id,
      );
      localStorage.setItem('deleteIds', JSON.stringify(newDeleteLocal));
      callback(product, option, 1, totalPrice, null, data);
    } else if (product && product?.quantity > 0) {
      data = await updateCart(cart.id, product.id, product.quantity + 1, product?.partnerPromotionId || index?.code);
      if (data) {
        callback(product, option, product.quantity + 1, totalPrice, null, data);
      }
    }
    setLoading(false);
  };

  const decreaseOrder = async (option) => {
    const product = await cart.entries.find(
      (value) => value.product.id === option.id && value.partnerPromotionId === index.code
    );
    totalPrice = totalPrice - getPriceWithoutCurrency(option.targetPrice);
    quantity = product.quantity - 1;
    setLoading(true);
    let data = null;
    if (quantity > 0) {
      data = await updateCart(cart.id, product.id, quantity, product?.partnerPromotionId || index?.code);
    }
    if (quantity === 0) {
      data = await deleteCartItems(cart.id, [product.id], false);
      const deleteId = JSON.parse(localStorage.getItem('deleteIds'));
      const hasLocalStorage = deleteId.find((v) => v.product.id === option.id);
      if (!hasLocalStorage) {
        deleteId.push(product);
        localStorage.setItem('deleteIds', JSON.stringify(deleteId));
        onOpenLiff(index?.code);
      }
    }
    if (data) {
      callback(product, option, quantity, totalPrice, null, data);
    }
    setLoading(false);
  };

  const isRequiredQtySelected = () => {
    return quantity + getQuantity() === orderTotal ? true : false;
  };

  const isQtyStepperDisabled = (quantityProduct) => {
    return quantityProduct && quantity ? false : isRequiredQtySelected();
  };

  const getIsDecrementDisabled = (quantityProduct, quantityOption) => {
    return (quantityProduct && quantity) || quantityOption > 0 ? false : true;
  };

  const getIsIncrementDisabled = (quantityProduct) => {
    return quantityProduct && quantity && isRequiredQtySelected()
      ? true
      : isRequiredQtySelected();
  };

  const getQuantity = () => {
    const entryInCartArr = cart.entries;
    let quantityOptions = 0;
    if (premiumItemsOption) {
      for (const target of premiumItemsOption) {
        for (const item of entryInCartArr) {
          if (item.product.id === target.id && item.partnerPromotionId === index.code) {
            if (item.product.id !== lastPremiumItemsId) {
              quantityOptions = quantityOptions + item.quantity;
            }
          }
        }
      }
      return quantityOptions;
    } else {
      return;
    }
  };

  const displayOptions = () => {
    const entryInCartArr = cart.entries;
    return premiumItemsOption.map((option, index) => {
      const quantityProduct = entryInCartArr.find((value) => {
        return value.product.id === option.id && value.partnerPromotionId;
      });

      let quantityOption = 0;
      for (const item of entryInCartArr) {
        if (item.product.id === option.id && item.partnerPromotionId) {
          if (item.product.id !== lastPremiumItemsId) {
            quantityOption = item.quantity;
          }
        }
      }

      const img =
        option.galleryImages[0].image_url ||
        '/images/promotion/image_empty.png';
      return (
        <section className="prm-choice-item" key={option.id}>
          <img style={{ width: '72px', height: '72px' }} src={img} />
          <div className="description">
            <div className="identifier">{option.identifier}
              <div className="font-black font-x-small font-stock">
                {displayStockLevelStatus(option.stock)}
              </div>
            </div>
            <div className="price-row">
              <div className="disc-price">
                ฿ {getPriceFormat(option.targetPrice)}
              </div>
              <div className="actual-price">
                ฿ {getPriceFormat(option.prices[0].price)}
              </div>
            </div>
          </div>
          <div>
            <QuantityStepper
              orderTotal={
                quantityProduct &&
                  quantityProduct.product.id === lastPremiumItemsId
                  ? quantity
                  : quantityOption
              }
              increaseOrder={() => {
                increaseOrder(option);
              }}
              decreaseOrder={() => {
                decreaseOrder(option);
              }}
              disableDecreaseStepper={getIsDecrementDisabled(
                quantityProduct,
                quantityOption,
              )}
              disableIncreaseStepper={getIsIncrementDisabled(quantityProduct)}
              disableStepperBox={isQtyStepperDisabled(quantityProduct)}
            />
          </div>
        </section>
      );
    });
  };

  const renderFooter = () => {
    return (
      <div className="prm-choice-footer" style={{ height: 'calc(15vh - 50px)' }}>
        <div onClick={() => { if (!isConfirmDisabled) closeLiffEvent(); }} className="footer-btn" style={{ backgroundColor: isConfirmDisabled ? '#d9d9d9' : '#2C2C2C', pointerEvents: isConfirmDisabled ? 'none' : 'auto' }}>
          <div className="btn-text" style={{}}>
            <div>ตกลง</div>
          </div>
        </div>
      </div>
    );
  };

  const isPwpTargetPriceZero = premiumItemsOption?.every((item) => getPriceWithoutCurrency(item.targetPrice) === 0) ?? false;
  const isConfirmDisabled = isPwpTargetPriceZero && !isRequiredQtySelected();

  return (
    <div className="mb-10" key={index}>
      <LoadingOverlay
        text="Loading"
        spinner
        active={loading}
        styles={{ wrapper: { width: '100%', minHeight: '100%' } }}
      />
      <div className="card-product-body-cart gift-card">
        <div className="gift-product-container">
          <div
            className="gift-label-div card-product-title-text-cart font-black"
            style={{ flex: '1 1 0', wordWrap: 'break-word' }}
          >
            สินค้าแลกซื้อ
          </div>
        </div>
        <div className="gift-info-container">
          <img className="gift-img" src={img} alt="gift image" />
          <div className="info-div">
            <div className="gift-title-container">
              <span
                className="cart-product-info-cart font-black"
                style={{ alignSelf: 'stretch', wordWrap: 'break-word' }}
              >
                {identifier}
                {premiumItemsOption && (
                  <div onClick={() => onOpenLiff(index?.code)}>
                    <span className="underline">เปลี่ยนสินค้า</span>
                    {' >'}
                  </div>
                )}
              </span>
              <div className="font-black font-x-small font-stock">
                {displayStockLevelStatus(stock)}
              </div>
            </div>
            <div
              className="cart-product-info-cart font-black"
              style={{ textAlign: 'right', wordWrap: 'break-word' }}
            >{`x${quantity}`}</div>
          </div>
        </div>
      </div>
      {isOpenLiff &&
        premiumItemsOption?.length > 0 &&
        cart?.entries?.length > 0 &&
        (<LiffPromotionList
          title={`เลือกสินค้าได้ ${orderTotal} ชิ้น`}
          onClose={() => { if (!isConfirmDisabled) closeLiffEvent(); }}
          isOpen={true}
          bgColor={'#ffffff'}
          disableClose={isConfirmDisabled}
        >
          <div
            className="content scroll-auto prm-choice"
            style={{ height: 'calc(75vh - 50px)' }}
          >
            {premiumItemsOption && (
              <>
                <div className="prm-current-qty">
                  <div className="qtyValue">
                    {quantity + getQuantity()} / {orderTotal}
                  </div>
                </div>
                {displayOptions()}
              </>
            )}
          </div>
          {renderFooter()}
        </LiffPromotionList>)
      }
    </div>
  );
};

export default PromotionItem;
